/** Concurrency limits for batch WebSocket operations (backend/rate-limit constraints). */
export const LIMIT_BATCH_DEPLOY = 50;
export const LIMIT_BATCH_DELETE = 50;
export const LIMIT_BATCH_DEACTIVATE = 50;
export const LIMIT_BATCH_RESTORE = 50;
export const LIMIT_BATCH_CLEAR_CACHE = 50;
export const LIMIT_BATCH_CLEAR_CUSTOM_CACHE = 50;
export const LIMIT_BATCH_FORCE_HTTPS = 25;
export const LIMIT_BATCH_ENABLE_HTTPS = 25;
export const LIMIT_BATCH_CERT = 25;
export const LIMIT_BATCH_IMPORT = 75;

/** AC-1949: hard cap on how many domains a single batch import may contain. */
export const MAX_BATCH_IMPORT = 2000;